import { FileChangeEvent, HelperUtils } from "@merri/common";

export class HelperMethods extends HelperUtils {
  static setFile(e: FileChangeEvent, key: string, fileMap: Map<string, File[]>): void {
    if (e.current) {
      if (fileMap.has(key)) {
        fileMap.get(key).push(e.current);
      } else {
        fileMap.set(key, [e.current]);
      }
    }

    if (e.previous) {
      const files = fileMap.get(key);
      const file = files?.find(i => i.name === e.previous.name);
      HelperUtils.removeItem(files, file);
    }
  }
}
